import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { spedRoutes } from 'SpedRoutes';
import { UserAuthProvider } from 'context/UserAuthContext';

import 'App.css';
import 'css/variables.css';

const router = createBrowserRouter(spedRoutes);

export const App = () => {
  return (
    <UserAuthProvider>
      <RouterProvider router={router} />
    </UserAuthProvider>
  );
}